export enum SalesPerPeriodReportTypeEnum {
    TOTAL = 'TOTAL',
    AVERAGE = 'AVERAGE'
}